/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const SearchResultContainerStyles = styled.div<any>`
  display: flex;
  align-items: center;
  .label {
    color: black;
    font-size: var(--typography-size-m2);
    font-weight: var(--typography-weight-semiRegular);
    line-height: var(--typography-size-l1);
    margin: 0;
    padding: 0;
    span {
      font-weight: var(--typography-weight-bold);
    }
  }
  .quantity-items {
    color: #9d9d9d;
    font-weight: var(--typography-weight-bold);
    font-size: var(--typography-size-s3);
    line-height: var(--typography-size-m2);
    margin-left: var(--spacing-margin-xxSmall);
  }
`
